import {
  Action,
  mkWidget,
  route,
  loadingAsyncState,
  async,
  string,
  unloadedAsyncState,
  any,
  hn,
  nothing,
  div,
  HttpResult
} from 'widgets-for-react'
import React from 'react'
import { styleguide as SG } from '../../../styleguide/main'

import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteCustomRoutes, CustomPagesState, CustomPage } from './types.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { searchResults } from '../../searchResults'
import { WordPress } from '../../wordpress/wordpress_api'
import { AxiosResponse } from 'axios'
import { PaginationResponse } from '../../wordpress/types_and_parser/extra_types.mod'
import { get_addresses } from '../blocks/custom_blocks/widgets/mapBlock'
import { remove } from 'diacritics'

export const country: CustomPage<CustomPagesState['country']> = {
  widget: s0 =>
    mkWidget({
      run: (setState: (_: Action<CustomPagesState['country']>) => void) => {
        return s0.fst.kind == 'country' ? (
          <>
            <main className='main main--default'>
              <div className='page page--countries'>
                <div className='page__content'>
                  <article className='page'>
                    {async<Immutable.List<WordPress.LocationResponse>>(() => nothing())(
                      s0.snd.response
                    ).run(a => setState(s => ({ ...s, response: a(s.response) })))}
                    <header className='hero hero--secondary'>
                      <div className='hero__inner container--xl grid--block'>
                        <div className='hero__content'>
                          <div className='hero__text'>
                            <h1 className='hero__title typo--4xl'>
                              {s0.snd.response.kind == 'loaded'
                                ? s0.snd.response.value
                                    .filter(
                                      l =>
                                        remove(l.acf.country.toLowerCase()) == s0.snd.country.toLowerCase()
                                    )
                                    .map(l => l.acf.country)
                                    .first()
                                : s0.snd.country.replace(/^\w/, c => c.toUpperCase())}
                            </h1>
                            <div className='hero__intro typo--m text--styled'>
                              {s0.snd.response.kind == 'loaded'
                                ? s0.snd.response.value
                                    .filter(
                                      l =>
                                        remove(l.acf.country.toLowerCase()) == s0.snd.country.toLowerCase()
                                    )
                                    .map(l => {
                                      return <p>{l.acf.text}</p>
                                    })
                                    .first()
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </header>
                    <div className='container--s grid--block locations'>
                      {s0.snd.response.kind == 'loaded' ?
                        <ul className='locations__list'>
                          {s0.snd.response.value
                            .filter(
                              l => remove(l.acf.country.toLowerCase()) == s0.snd.country.toLowerCase()
                            )
                            .map(l =>
                              l.acf.offices && l.acf.offices.length > 0
                                ? l.acf.offices.map(o => (
                                    <li className='locations__item location'>
                                      <h3 className='location__title typo--s'>{o.function}</h3>
                                      <ul className='location__address typo--2xs'>
                                        <li>
                                          {[o.street, o.number, o.number_addition].join(' ')}
                                        </li>
                                        <li>{[o.postal_code, o.city, o.country].join(' ')}</li>
                                        {o.phone_number ? (
                                          <li>{['T', o.phone_number].join(' ')}</li>
                                        ) : null}
                                      </ul>
                                    </li>
                                  ))
                                : null
                            )
                          }
                        </ul>
                       : (
                        <div className="loader">
                          <div className="loader__inner"></div>
                        </div>
                       )}
                    </div>
                  </article>
                </div>
              </div>
            </main>
          </>
        ) : null
      }
    }),
  route: route<{ country: string }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/:lang?/(land|country)/:country',
    s => ({ kind: 'country', country: s.country || '' })
  ),
  getState: (s: PublicSiteState) => ({ ...s.country }),
  setState: (s: PublicSiteState, ss: CustomPagesState['country']) => ({
    ...s,
    country: ss
  }),
  updateStateBasesOnRoute: (s, r) => {
    return r.kind != 'country'
      ? s
      : {
          ...s,
          country: {
            response: get_addresses(),
            country: r.country
          }
        }
  }
}
